module.exports = __webpack_public_path__ + "img/map-infographic.29f402fd.svg";